export function VideoRecordingListLoadingPlaceholder() {
  return (
    <div className="list-group list-group-flush">
      <div className="placeholder-glow list-group-item px-0">
        <div className="placeholder col-6"></div>
      </div>
      <div className="placeholder-glow list-group-item px-0">
        <div className="placeholder col-4"></div>
      </div>
    </div>
  );
}
